<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppMultiSelect } from '@shared/ui/selects'

import { useLessonRecurringFilters } from '../../model/lessons/lesson-recurring-filters.hook'

defineOptions({
  name: 'LessonRecurringFilters',
})

const {
  refGender,
  refSpecialFeatures,
  refAccent,
  refCategories,
  refGenderOptions,
  refSpecialFeatureOptions,
  refAccentOptions,
  refCategoryOptions,
  refIsDisabled,
} = useLessonRecurringFilters()
</script>

<template>
  <div class="lesson-recurring-filters">
    <AppText
      name="body1-medium"
      color="slate-900"
    >
      Tutor filters
    </AppText>
    <AppMultiSelect
      v-model="refGender"
      :options="refGenderOptions"
      label="Gender"
      placeholder="All"
      :disabled="refIsDisabled"
      clearable
    />
    <AppMultiSelect
      v-model="refSpecialFeatures"
      :options="refSpecialFeatureOptions"
      label="Special features"
      placeholder="All"
      :disabled="refIsDisabled"
      clearable
    />
    <AppMultiSelect
      v-model="refAccent"
      :options="refAccentOptions"
      label="Accent"
      placeholder="All"
      :disabled="refIsDisabled"
      clearable
    />
    <AppMultiSelect
      v-model="refCategories"
      :options="refCategoryOptions"
      label="Categories"
      placeholder="All"
      :disabled="refIsDisabled"
      clearable
    />
  </div>
</template>

<style scoped lang="scss" src="./LessonRecurringFilters.scss" />
